<template>
    <div>
        <div>
            <h2 style="text-align: center;padding-top: 20px;font-size: 30px;color: #407338">Userguide</h2>
        </div>

        <div style="padding-top: 10px">
            <h2 style="text-align: left;padding-top: 10px;font-size: 24px;color: #333a61;margin-left: 50px">1. Syntenic Gene</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">1.1 Search across gene ID</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                Redirect to
                <a style="color: #333a61" href="http://brassicadb.cn/#/syntenic-gene/" target="_blank">
                    Syntenic Gene
                </a><br/><br/>
                1.1.1 Input gene ID.<br/>
                1.1.2 Select flank genes number.<br/>
                1.1.3 Select genomes to show.<br/>
                1.1.4 Click "ADD" button to add genomes to show or "REMOVE" button to remove genome in selected genomes.<br/>
                1.1.5 Click "Search" button to search.<br/><br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Syntenic_Gene_1.jpg">
            </h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">1.2 Search across results</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                1.2.1 Click "•" or click ".." to search the gene in other page.<br/>
                1.2.2 Click the tree will show phylogenetic tree of the genes in this row.<br/>
                1.2.3 Click the picture will show the multiple sequence alignment of the genes in this row.<br/>
                1.2.4 Scroll the bottom scroll bar to see more results.<br/>
            </h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px;">
                Note: When the mouse is placed on "•" will display the detailed information.<br/><br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Syntenic_Gene_2.jpg">
            </h2>

        </div>

        <div style="padding-top: 10px">
            <h2 style="text-align: left;padding-top: 10px;font-size: 24px;color: #333a61;margin-left: 50px">2. Annotations</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">2.1 Search across gene ID</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                Redirect to
                <a style="color: #333a61" href="http://brassicadb.cn/#/Annotations/" target="_blank">
                    Annotations
                </a><br/><br/>
                2.1.1 Input keyword.<br/>
                2.1.2 Select type.<br/>
                2.1.3 Select genome to search.<br/>
                2.1.4 Click "Search" button  to search.<br/><br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Annotations_2.jpg">
            </h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">2.2 Search across results</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                2.2.1 Click one button to search one database.<br/><br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Annotations_3.jpg">
            </h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">2.3 Search across results</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                2.3.1 Click gene ID to search the gene in other page.<br/>
                2.3.2 Click annotation ID to search the gene on the annotation website.<br/>
                2.3.3 Click "Export result as Excel" button to download the result as xlsx.<br/><br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Annotations_4.jpg">
            </h2>
        </div>

        <div style="padding-top: 10px">
            <h2 style="text-align: left;padding-top: 10px;font-size: 24px;color: #333a61;margin-left: 50px">3. Flanking region</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">3.1 Search across gene ID</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                Redirect to
                <a style="color: #333a61" href="http://brassicadb.cn/#/FlankingRegion/" target="_blank">
                    Flanking region
                </a><br/><br/>
                3.1.1 Input gene ID or coordinate.<br/>
                3.1.2 Input flank length.<br/>
                3.1.3 Select genome to search.<br/>
                3.1.4 Click "Search" button to search.<br/><br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Flanking_region_1.jpg">
            </h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">3.2 Search across results</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                3.2.1 Click gene ID to search the gene in other page.<br/>
                3.2.2 Click "Export result as Excel" button to download the result as xlsx.<br/><br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Flanking_region_2.jpg">
            </h2>
        </div>

        <div style="padding-top: 10px">
            <h2 style="text-align: left;padding-top: 10px;font-size: 24px;color: #333a61;margin-left: 50px">4. Nonsyntenic Orth</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">4.1 Search across gene ID</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                Redirect to
                <a style="color: #333a61" href="http://brassicadb.cn/#/NonSyntenicOrthologs/" target="_blank">
                    Nonsyntenic Orth
                </a><br/><br/>
                4.1.1 Input gene ID, "query" indicates blast query file, while "subject" indicates blast library file<br/>
                4.1.2 Select genome to search.<br/>
                4.1.3 Click "Search" button to search.<br/><br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Nonsyntenic_orth_1.jpg">
            </h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">4.2 Search across results</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                4.2.1 Click gene ID to search the gene in other page<br/>
                4.2.2 Click "Export result as Excel" button to download the result as xlsx<br/><br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Nonsyntenic_orth_2.jpg">
            </h2>
        </div>

        <div style="padding-top: 10px">
            <h2 style="text-align: left;padding-top: 10px;font-size: 24px;color: #333a61;margin-left: 50px">5. Gene sequence</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">5.1 Search across gene ID</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                Redirect to
                <a style="color: #333a61" href="http://brassicadb.cn/#/GeneSequence/" target="_blank">
                    Gene sequence
                </a><br/><br/>
                5.1.1 Input gene ID.<br/>
                5.1.2 Click "Search" button to search.<br/><br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Gene_sequence_1.jpg">
            </h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">5.2 Save result</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                5.2.3 Click "download" button to download the result as fasta<br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Gene_sequence_2.jpg">
            </h2>
        </div>

        <div style="padding-top: 10px">
            <h2 style="text-align: left;padding-top: 10px;font-size: 24px;color: #333a61;margin-left: 50px">6. Genomic sequence retrieval</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">6.1 Search across coordinates</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                Redirect to
                <a style="color: #333a61" href="http://brassicadb.cn/#/GenomicSequenceRetrieval/" target="_blank">
                    Genomic sequence retrieval
                </a><br/><br/>
                6.1.1 Select a genome.<br/>
                6.1.2 Select a chromosome.<br/>
                6.1.3 Input start position.<br/>
                6.1.4 input end position.<br/>
                6.1.5 Select the strand.<br/>
                6.1.6 Click "Search" button to search.<br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Sequence_interception_1.jpg">
            </h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">6.2 Save result</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                6.2.1 View the results in the box on the right.<br/>
                6.2.2 Click "Download as fasta" button to download the result as fasta.<br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Sequence_interception_2.jpg">
            </h2>
        </div>

        <div style="padding-top: 10px">
            <h2 style="text-align: left;padding-top: 10px;font-size: 24px;color: #333a61;margin-left: 50px">7. MicroSynteny</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">7.1 Search across two region</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                Redirect to
                <a style="color: #333a61" href="http://brassicadb.cn/#/RegionMicroSynteny/" target="_blank">
                    MicroSynteny
                </a><br/><br/>
                7.1.1 Select search type, Genes or Fragments.<br/>
                7.1.2 Input two gene IDs and their upstream and downstream lengths.<br/>
                7.1.3 Click "SUBMIT" to search.<br/>
                7.1.4 Get the microsynteny vector illustration, you can scroll the mouse wheel to zoom, 
                      hover over the link to see the specific information, 
                      hover the mouse over the small rectangle to see which gene, 
                      and right-click to download the svg picture for editing.<br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/RegionMicroSynteny.jpg">
            </h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">7.2 Figure details</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                7.2.1 The horizontal rectangle represents the gene.<br/>
                7.2.2 The vertical rectangle represents the cds area of the gene.<br/>
                7.2.3 The red means the gene direction is positive, while dark blue means the gene direction is negative.<br/>
                <img style="margin: 0 auto;width: 200px;height: 150px" src="../assets/img/Brassicadb_help/RegionMicroSynteny_1.jpg">
                <img style="margin: 0 auto 0 30px;width: 200px;height: 150px" src="../assets/img/Brassicadb_help/RegionMicroSynteny_2.jpg">
            </h2>
        </div>

        <div style="padding-top: 10px">
            <h2 style="text-align: left;padding-top: 10px;font-size: 24px;color: #333a61;margin-left: 50px">8. Syntenic Figure</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">8.1 Search across two genomes</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                Redirect to
                <a style="color: #333a61" href="http://brassicadb.cn/#/SyntenicFigure/" target="_blank">
                    Syntenic Figure
                </a><br/><br/>
                8.1.1 Select query genome.<br/>
                8.1.2 Select subject genome.<br/>
                8.1.3 Click "SUBMIT" to search.<br/>
                8.1.4 Click "Transpose" to swap the X and Y axis.<br/>
                8.1.5 Right-click to save images as SVG, PNG, and JPG files.<br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Synteny_figure.jpg">
            </h2>
        </div>

        <div style="padding-top: 10px">
            <h2 style="text-align: left;padding-top: 10px;font-size: 24px;color: #333a61;margin-left: 50px">9. Transcriptome</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">9.1 Search across genome, GEO Serial and Gene ID</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                Redirect to
                <a style="color: #333a61" href="http://brassicadb.cn/#/Transcriptome/" target="_blank">
                    Transcriptome
                </a><br/><br/>
                9.1.1 Select a genome.<br/>
                9.1.2 Select a GEO Serial.<br/>
                9.1.3 Input gene ID.<br/>
                9.1.4 Click "GEO Details" to jump to NCBI to see the details of GEO Serial.<br/>
                9.1.5 Click "SUBMIT" to search.<br/>
                9.1.6 Right-click to save images as SVG, PNG, and JPG files.<br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Transcriptome.jpg">
            </h2>
        </div>

        <div style="padding-top: 10px">
            <h2 style="text-align: left;padding-top: 10px;font-size: 24px;color: #333a61;margin-left: 50px">10. Primer Design</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">10.1 Design primer by gene ID or fragments</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                Redirect to
                <a style="color: #333a61" href="http://brassicadb.cn/#/PrimerDesign/" target="_blank">
                    Primer Design
                </a><br/><br/>
                10.1.1 Select search type, Genes or Fragments.<br/>
                10.1.2 Input gene ID.<br/>
                10.1.3 Click "SUBMIT" to search.<br/>
                10.1.4 Click on each tag to see the meaning of each parameter for Primer3.<br/>
                10.1.5 Click "Export result as Excel" button to download the result as xlsx.<br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Primer_design.jpg">
            </h2>
        </div>

        <div style="padding-top: 10px">
            <h2 style="text-align: left;padding-top: 10px;font-size: 24px;color: #333a61;margin-left: 50px">11. Polymorph</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">11.1 Search across gene ID or fragments</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                Redirect to
                <a style="color: #333a61" href="http://brassicadb.cn/#/Polymorph/" target="_blank">
                    Polymorph
                </a><br/><br/>
                11.1.1 Select search type, Genes or Fragments.<br/>
                11.1.2 Select the dataset.<br/>
                11.1.3 Input two gene IDs and their upstream and downstream lengths.<br/>
                11.1.4 Select variation type.<br/>
                11.1.5 Click "SUBMIT" to search.<br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Polymorph_1.jpg">
            </h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">11.2 Variation data</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                11.2.1 Click "Export result as Excel" button to download the result as xlsx.<br/>
                11.2.2 Click the gene ID button to invoke the popover.<br/>
                11.2.3 Click on the variation site for further information.<br/>
                <img style="margin: 0 auto;width: 1000px;" src="../assets/img/Brassicadb_help/Polymorph_2.jpg">
            </h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">11.3 Variation details</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                11.3.1 Select a query group.<br/>
                11.3.2 Select background group.<br/>
                11.3.3 Click "SUBMIT" to search.<br/>
                11.3.4 The chi-square test results of variation.<br/>
                <img style="margin: 0 auto;width: 1000px;" src="../assets/img/Brassicadb_help/Polymorph_3.jpg">
            </h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">11.4 Distribution of a single variation site</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                11.4.1 Click "Download the original image" button to download the image with the label.<br/>
                11.4.2 Click "Download table of materials" button to download the table with the corresponding material number.<br/>
                11.4.3 Click "Download as SVG" button to download the image as SVG.<br/>
                <img style="margin: 0 auto;width: 1000px;" src="../assets/img/Brassicadb_help/Polymorph_4.jpg">
            </h2>
        </div>

        <div style="padding-top: 10px">
            <h2 style="text-align: left;padding-top: 10px;font-size: 24px;color: #333a61;margin-left: 50px">12. Multiple sequence alignment</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">12.1 Search by gene, CDS or protein</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                Redirect to
                <a style="color: #333a61" href="http://brassicadb.cn/#/MSA/" target="_blank">
                    Multiple sequence alignment
                </a><br/><br/>
                12.1.1 Select search type, Gene, CDS or Protein.<br/>
                12.1.2 Input or delete gene ID.<br/>
                12.1.3 Add gene ID input box or submit.<br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Multiple_sequence_alignment_1.jpg">
            </h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">12.2 Visualization of multiple sequence alignment results</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                12.2.1 Click "Download sequence" button to download the original sequence.<br/>
                12.2.2 Click on a single sequence to download a single sequence.<br/>
                <img style="margin: 0 auto;width: 1000px;" src="../assets/img/Brassicadb_help/Multiple_sequence_alignment_2.jpg">
            </h2>
        </div>

        <div style="padding-top: 10px">
            <h2 style="text-align: left;padding-top: 10px;font-size: 24px;color: #333a61;margin-left: 50px">13. Gene Phylogeny</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">13.1 Search across gene ID or fragments</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                Redirect to
                <a style="color: #333a61" href="http://brassicadb.cn/#/phylogeneticTree/" target="_blank">
                    Gene Phylogeny
                </a><br/><br/>
                13.1.1 Select search type, Gene, CDS or Protein.<br/>
                13.1.2 Input or delete gene ID.<br/>
                13.1.3 Add gene ID input box or submit.<br/>
                <img style="margin: 0 auto;width: 1000px" src="../assets/img/Brassicadb_help/Phylogenetic_trees_1.jpg">
            </h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 70px">13.2 Distribution of a single variation site</h2>
            <h2 style="text-align: left;padding-top: 10px;font-size: 20px;color: #333a61;margin-left: 100px;">
                13.2.1 Click "Download sequence" button to download the original sequence.<br/>
                13.2.2 Click "Download newick" button to download the newick data.<br/>
                <img style="margin: 0 auto;width: 1000px;" src="../assets/img/Brassicadb_help/Phylogenetic_trees_2.jpg">
            </h2>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Userguide"
    }
</script>

<style>

</style>